export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      MemberInfo: [
        {
          UserIdentity: 'member001',
          MemberKbnCd: 1,
          AvatarUrl: 'http://google/1.jpg',
          UserName: 'クライアント太郎',
          MailAddress: 'aaa@aaa.com',
          Sex: 1,
          Birthday: '1980/10/22',
          ComplaintCount: 6,
          NgWordUseCount: 4,
          UserState: 1
        },
        {
          UserIdentity: 'member002',
          MemberKbnCd: 2,
          AvatarUrl: 'http://google/1.jpg',
          UserName: 'メンター太郎',
          MailAddress: 'aaa@aaa.com',
          Sex: 1,
          Birthday: '1980/10/22',
          ComplaintCount: 12,
          NgWordUseCount: 10,
          UserState: 1
        },
        {
          UserIdentity: 'member003',
          MemberKbnCd: 2,
          AvatarUrl: 'http://google/1.jpg',
          UserName: 'プロメンター太郎',
          MailAddress: 'aaa@aaa.com',
          Sex: 2,
          Birthday: '1980/10/22',
          ComplaintCount: 1,
          NgWordUseCount: 0,
          UserState: 1
        }
      ]
    }
  }
}